import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Stack, Typography, useMediaQuery, useTheme, } from "@mui/material";
import Icon from "@shared/components/Icon";
const DescriptionService = (props) => {
    const { title, isDark = false, component = "p", spacing, mobileSpacing = "24", size = "M", dynamicList = [], } = props;
    const theme = useTheme();
    const isMobile = !useMediaQuery(theme.breakpoints.up("md"));
    const isLarge = size === "L";
    const isMedium = size === "M";
    const isSmall = size === "S";
    return (_jsxs(Stack, { spacing: 1.5, sx: {
            marginTop: { xs: 2, md: 0 },
            alignItems: isSmall ? "center" : "initial",
        }, children: [title !== "" && (_jsx(Typography, { component: component || "h3", color: isDark ? "primary.contrastText" : "initiale", sx: {
                    fontSize: "18px",
                    lineHeight: "133%",
                    letterSpacing: "2%",
                    fontWeight: 600,
                    pb: "8px",
                }, children: title })), _jsx(Stack, { flexDirection: { xs: "column", md: "row" }, divider: isSmall && (_jsx(Divider, { sx: {
                        width: { md: "1px" },
                        height: { xs: "1px", md: "initial" },
                        backgroundColor: "border.default",
                    } })), sx: {
                    width: { xs: "100%", md: "initial" },
                    justifyContent: isSmall ? "center" : "initial",
                    gap: { xs: `${mobileSpacing}px`, md: `${spacing}px` },
                }, children: dynamicList.map((card) => (_jsxs(Stack, { sx: {
                        flexGrow: 1,
                        flexBasis: 0,
                        gap: 1.5,
                        ...(isLarge && {
                            backgroundColor: isLarge ? "background.paper" : "initial",
                            outline: "1px solid",
                            outlineColor: "text.secondary",
                            p: { xs: "32px 24px", md: "40px 32px" },
                        }),
                        ...(isSmall && {
                            alignItems: "center",
                            justifyContent: "center",
                            maxWidth: { xs: "100%", md: "244px" },
                            gap: "2px",
                        }),
                    }, children: [isMedium && _jsx(Divider, { sx: { backgroundColor: card.borderColor } }), _jsxs(Stack, { sx: {
                                gap: 0,
                                ...(isLarge && { gap: 3 }),
                                ...(isMedium && { gap: 1.5 }),
                            }, children: [card?.icon?.icon && (_jsx(Icon, { ...card.icon, 
                                    // TODO CAN'T CHANGE CSS PROPERTIES
                                    style: isLarge && !isMobile
                                        ? {
                                            minWidth: "48px",
                                            minHeight: "48px",
                                        }
                                        : {
                                            minWidth: "36px",
                                            minHeight: "36px",
                                        } })), isLarge && (_jsx(Divider, { sx: { backgroundColor: card.borderColor } })), card?.title && (_jsx(Typography, { color: isDark ? "primary.contrastText" : "text.primary", component: card.component ?? "p", sx: {
                                        fontWeight: 600,
                                        fontSize: 14,
                                        lineHeight: "150%",
                                        ...(isLarge && {
                                            fontSize: { xs: 16, md: 18 },
                                            lineHeight: { xs: "125%", md: "133%" },
                                        }),
                                        ...(isSmall && { fontSize: { xs: 14, md: 16 } }),
                                    }, children: card?.title }))] }), _jsx(Typography, { color: isDark ? "primary.contrastText" : "text.secondary", sx: {
                                fontSize: 14,
                                lineHeight: "150%",
                                ...(isLarge && {
                                    fontSize: { xs: 14, md: 16 },
                                    lineHeight: { xs: "150%", md: "160%" },
                                }),
                                ...(isSmall && {
                                    textAlign: "center",
                                    fontSize: { xs: 12, md: 14 },
                                }),
                            }, children: card?.description })] }, card?.title))) })] }));
};
export default DescriptionService;
